import { type FC, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Alert, Button } from 'shared/ui'
import { type Segment } from 'entities/Segment/model/Segment'
import { type SegmentBox } from 'entities/Segment'
import { type FilterEditorStore, FilterEditor } from 'widgets/FilterEditor'
import { RE_ENROLL_CONTACTS_FILTER_KEYS } from 'widgets/ContactEnrollment/store'
import styles from './styles.module.scss'

export interface IFilterEditorProps {
  filterEditorStore: FilterEditorStore
  segmentBox: SegmentBox
  isViewOnly?: boolean
  onCancel: () => void
  onApply: (segment: Segment) => void
}

export const FilterEditorContent: FC<IFilterEditorProps> = observer(
  ({ onApply, onCancel, isViewOnly, filterEditorStore, segmentBox }) => {
    const { hasChanges } = segmentBox
    const { groups } = filterEditorStore
    const segment = groups.toSegment({
      id: segmentBox.segment?.id,
      organization_id: segmentBox.segment?.organizationId,
    })

    // TODO: Temporary solution must to be removed/updated after implementing filter on the backend side (as other filters)
    const isLocalGroup = !!groups.groups.find((group) => group.isLocal)

    const disabled = !hasChanges || !filterEditorStore.isReady || isLocalGroup

    useEffect(() => {
      filterEditorStore.setViewOnly(Boolean(isViewOnly))
    }, [isViewOnly])

    useEffect(() => {
      filterEditorStore.setShouldShowAlert(
        groups.filters.some((filter) => RE_ENROLL_CONTACTS_FILTER_KEYS.includes(filter.key))
      )
    }, [groups.filters])

    return (
      <div className={styles.filterContainer}>
        <div className={styles.filterMain}>
          <div className={styles.filterScroll}>
            <FilterEditor store={filterEditorStore} />
          </div>

          {!isViewOnly && (
            <div className={styles.filterActions}>
              <Button
                typeBtn='text'
                text='Apply'
                onClick={() => {
                  if (segment) onApply(segment)
                }}
                disabled={disabled}
              />
              <div className={styles.divider} />
              <Button typeBtn='text' text='Cancel' onClick={() => onCancel()} />
            </div>
          )}
        </div>
        {filterEditorStore.shouldShowAlert && (
          <Alert
            item={{
              type: 'infoBlue',
              desc: 'Only new incoming messages will trigger enrollment. Past messages will be ignored.',
            }}
            onClose={() => filterEditorStore.setShouldShowAlert(false)}
          />
        )}
      </div>
    )
  }
)
